import { z } from 'zod'

export const searchParamsNewsCategory = z
  .enum([
    'Automotive',
    'Business',
    'Entertainment',
    'Food',
    'Health',
    'Lifestyle',
    'Money',
    'News',
    'Politics',
    'Science',
    'Shopping',
    'Sports',
    'Technology',
    'Travel',
    'Games',
  ])
  .catch('News')

export type SearchParamsNewsCategory = z.infer<typeof searchParamsNewsCategory>
